import { render, staticRenderFns } from "./SkeletonSpinner.vue?vue&type=template&id=1a28ee2d&"
import script from "./SkeletonSpinner.vue?vue&type=script&lang=js&"
export * from "./SkeletonSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports